import { AnyAction } from 'redux';
import { put } from 'redux-saga/effects';

import * as actions from '@/store/actions';
import { apiClient, throwSubmissionError } from '@/utils';
import { AxiosResponse } from 'axios';

export function* fetchSystemSettings(action: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.get('/settings/system');

        yield put(actions.FETCH_SYSTEM_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_SYSTEM_SETTINGS.failure(error));
    }
}

export function* editSystemSettings({ payload }: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.put('/settings/system', payload);

        yield put(actions.EDIT_SYSTEM_SETTINGS.success(response));
    } catch (error) {
        yield put(actions.EDIT_SYSTEM_SETTINGS.failure(throwSubmissionError(error)));
    }
}

